<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0798 5.05022V28.9522C21.0798 29.4874 20.6582 29.9212 20.138 29.9212C19.8379 29.9204 19.541 29.8593 19.265 29.7415C18.989 29.6238 18.7394 29.4518 18.5311 29.2358L13.6555 24.2181C13.4253 23.9793 13.1494 23.7893 12.8443 23.6593C12.5392 23.5293 12.211 23.4619 11.8794 23.4612H11.0362C7.57021 23.4612 4.75977 20.5692 4.75977 17.0012C4.75977 13.4333 7.57021 10.5412 11.0362 10.5412H11.8794C12.5458 10.5412 13.1843 10.2692 13.6548 9.78438L18.5304 4.76598C18.7389 4.5499 18.9888 4.37794 19.265 4.26031C19.5413 4.14268 19.8384 4.08177 20.1386 4.08122C20.6582 4.08122 21.0798 4.51506 21.0798 5.05022ZM24.851 12.4153C24.6132 12.1693 24.4802 11.8405 24.4802 11.4983C24.4802 11.1561 24.6132 10.8273 24.851 10.5813C24.9672 10.4612 25.1064 10.3657 25.2602 10.3004C25.4141 10.2352 25.5795 10.2015 25.7466 10.2015C25.9137 10.2015 26.0791 10.2352 26.233 10.3004C26.3868 10.3657 26.526 10.4612 26.6422 10.5813C30.1054 14.1269 30.1054 19.8756 26.6422 23.4211C26.526 23.5412 26.3868 23.6368 26.233 23.702C26.0791 23.7673 25.9137 23.8009 25.7466 23.8009C25.5795 23.8009 25.4141 23.7673 25.2602 23.702C25.1064 23.6368 24.9672 23.5412 24.851 23.4211C24.6132 23.1751 24.4802 22.8463 24.4802 22.5041C24.4802 22.1619 24.6132 21.8331 24.851 21.5871C27.3242 19.0541 27.3242 14.9483 24.851 12.4153Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 34,
    },
    height: {
      type: Number,
      default: 34,
    },
    fill: {
      type: String,
      default: "#8D5185",
    },
  },
};
</script>

<style lang="scss" scoped></style>
